module.exports = __webpack_public_path__ + "img/cute_natural_doodle_11.14a9e7f7.png";